import styled from "@emotion/styled";

import { SkiliticsIcon, ToolBarButton } from "@skilitics/designer-ui-components";
import { useFormatMessage, type FormatMessages } from "@skilitics/localization";

import { useUndoRedo } from "../../state/useUndoRedo";

const placement = "left";

const ComponentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
`;

export const ActionBar = () => {
  const formatMessage = useFormatMessage(formatStrings);
  const { canRedo, canUndo, undo, redo } = useUndoRedo();

  return (
    <ComponentContainer>
      <ToolBarButton
        tooltip={formatMessage("undo")}
        placement={placement}
        onClick={undo}
        disabled={!canUndo}
        data-test="toolbar-undo"
      >
        <SkiliticsIcon icon="tools-undo-redo" size={20} />
      </ToolBarButton>

      <ToolBarButton
        tooltip={formatMessage("redo")}
        placement={placement}
        onClick={redo}
        disabled={!canRedo}
        data-test="toolbar-redo"
      >
        <SkiliticsIcon icon="tools-undo-redo" flip="horizontal" size={20} />
      </ToolBarButton>
    </ComponentContainer>
  );
};

const formatStrings = {
  undo: {
    en: "Undo",
  },
  redo: {
    en: "Redo",
  },
} satisfies FormatMessages;
